import { api, toList } from '../apiClient';

export const analyticsService = {
  /** POST /analytics/track — track a frontend event */
  track: (data) => api.post('/analytics/track', data),

  /** GET /analytics/business/{businessId} */
  getByBusiness: (businessId, params = {}) =>
    api.get(`/analytics/business/${businessId}`, { params }),

  /** GET /admin/dashboard */
  getAdminDashboard: () => api.get('/admin/dashboard'),

  /** GET /admin/analytics/revenue?days=N */
  getRevenueTimeSeries: (days = 30) =>
    api.get('/admin/analytics/revenue', { params: { days } }),

  /** GET /admin/analytics/top-businesses?limit=N */
  getTopBusinesses: (limit = 10) =>
    api.get('/admin/analytics/top-businesses', { params: { limit } }),

  /** GET /admin/analytics/top-businesses-by-views?limit=N */
  getTopBusinessesByViews: (limit = 10) =>
    api.get('/admin/analytics/top-businesses-by-views', { params: { limit } }),
};
